<script setup>
defineProps({
  error: { type: String, default: '' },
  label: { type: String, required: true },
  modelValue: { type: String, default: '' },
  placeholder: { type: String, required: true },
});

const emit = defineEmits(['update:modelValue']);
</script>

<template>
  <label class="grid gap-1.5">
    <span class="sr-only">{{ label }}</span>
    <span
      class="relative z-10 -mb-[calc(100%-2.75rem)] ml-4 pt-4 text-xl leading-6 text-lais-text"
      aria-hidden="true"
    >
      {{ label }}
    </span>
    <textarea
      :value="modelValue"
      rows="2"
      :placeholder="placeholder"
      :aria-label="label"
      :aria-invalid="Boolean(error)"
      class="min-h-[118px] w-full resize-y rounded-[12px] rounded-br-none border bg-white px-3 pb-3 pt-[46px] text-[1.2rem] font-normal leading-6 text-lais-text-body outline-none transition-colors placeholder:text-lais-text-muted focus:border-lais-primary"
      :class="
        error
          ? 'border-lais-danger text-lais-danger'
          : 'border-lais-border hover:border-lais-primary-400'
      "
      @input="emit('update:modelValue', $event.target.value)"
    />
    <span
      v-if="error"
      class="ml-[19px] text-[0.85rem] font-bold leading-5 text-lais-danger"
    >
      {{ error }}
    </span>
  </label>
</template>
